module.exports = __webpack_public_path__ + "img/space1.26831fe6.jpg";